import { render, staticRenderFns } from "./SecretaryRecord.vue?vue&type=template&id=ed07ab00&"
import script from "./SecretaryRecord.vue?vue&type=script&lang=js&"
export * from "./SecretaryRecord.vue?vue&type=script&lang=js&"
import style0 from "./SecretaryRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports